import Backbone from 'backbone';

export const MessagingConfig = Backbone.Model.extend({
    url: '/messaging/api/config/',
    defaults: {
        has_joinos: false,
        has_sms: false,
        has_contacts: false,
        sms_cost: 5
    }
});



// WEBPACK FOOTER //
// ./messaging/models/config.js